import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelRadio as _vModelRadio, withDirectives as _withDirectives, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "space-y-4 p-4 sm:p-6 lg:p-8" }
const _hoisted_2 = { class: "text-xl font-semibold text-gray-800" }
const _hoisted_3 = { class: "border-b border-gray-200 bg-gradient-to-r from-emerald-50 to-white px-5 py-6 sm:px-8 sm:py-8" }
const _hoisted_4 = { class: "flex flex-col gap-5 sm:flex-row sm:items-center sm:justify-between" }
const _hoisted_5 = { class: "flex items-start gap-4" }
const _hoisted_6 = { class: "flex h-12 w-12 flex-none items-center justify-center rounded-xl bg-[#25D366] p-3 text-white shadow-sm" }
const _hoisted_7 = { class: "mb-1 text-sm font-medium text-emerald-700" }
const _hoisted_8 = { class: "text-2xl font-semibold tracking-tight text-gray-900" }
const _hoisted_9 = { class: "mt-2 max-w-2xl text-sm leading-6 text-gray-600" }
const _hoisted_10 = { class: "grid divide-y divide-gray-200 lg:grid-cols-5 lg:divide-x lg:divide-y-0" }
const _hoisted_11 = { class: "p-5 sm:p-8 lg:col-span-3" }
const _hoisted_12 = { class: "text-base font-semibold text-gray-900" }
const _hoisted_13 = { class: "mt-1 text-sm text-gray-600" }
const _hoisted_14 = { class: "mt-6 space-y-5" }
const _hoisted_15 = { class: "flex gap-4" }
const _hoisted_16 = { class: "text-sm font-semibold text-gray-800" }
const _hoisted_17 = { class: "mt-1 text-sm leading-5 text-gray-600" }
const _hoisted_18 = { class: "flex gap-4" }
const _hoisted_19 = { class: "text-sm font-semibold text-gray-800" }
const _hoisted_20 = { class: "mt-1 text-sm leading-5 text-gray-600" }
const _hoisted_21 = { class: "flex gap-4" }
const _hoisted_22 = { class: "text-sm font-semibold text-gray-800" }
const _hoisted_23 = { class: "mt-1 text-sm leading-5 text-gray-600" }
const _hoisted_24 = { class: "bg-gray-50 p-5 sm:p-8 lg:col-span-2" }
const _hoisted_25 = { class: "rounded-xl border border-gray-200 bg-white p-5 shadow-sm" }
const _hoisted_26 = { class: "sr-only" }
const _hoisted_27 = {
  class: "text-sm font-semibold text-gray-900",
  "aria-hidden": "true"
}
const _hoisted_28 = { class: "mt-3 space-y-2" }
const _hoisted_29 = ["value", "disabled"]
const _hoisted_30 = { class: "flex items-center gap-2 text-sm font-medium text-gray-900" }
const _hoisted_31 = { class: "mt-0.5 block text-xs leading-5 text-gray-500" }
const _hoisted_32 = { class: "flex items-center gap-2 text-sm font-medium" }
const _hoisted_33 = { class: "mt-0.5 block text-xs leading-5" }
const _hoisted_34 = { class: "mt-5 rounded-xl border border-gray-200 bg-white p-5 shadow-sm" }
const _hoisted_35 = { class: "flex items-center gap-2 text-sm font-semibold text-gray-900" }
const _hoisted_36 = { class: "mt-2 text-sm leading-6 text-gray-600" }
const _hoisted_37 = { class: "mt-5 rounded-xl border border-emerald-100 bg-emerald-50 p-5" }
const _hoisted_38 = { class: "text-base font-semibold text-gray-900" }
const _hoisted_39 = { class: "mt-2 text-sm leading-6 text-gray-600" }
const _hoisted_40 = { class: "mt-3 flex items-start text-xs leading-5 text-gray-500" }
const _hoisted_41 = { class: "flex justify-end px-4 sm:px-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UiPageHeader = _resolveComponent("UiPageHeader")!
  const _component_UiBadge = _resolveComponent("UiBadge")!
  const _component_UiButton = _resolveComponent("UiButton")!
  const _component_UiPanel = _resolveComponent("UiPanel")!
  const _component_UiBackButton = _resolveComponent("UiBackButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_UiPageHeader, null, {
      info: _withCtx(() => [
        _createElementVNode("h1", _hoisted_2, _toDisplayString($setup.t('core.entity.Integrations')), 1 /* TEXT */)
      ]),
      _: 1 /* STABLE */
    }),
    _createVNode(_component_UiPanel, {
      "no-padding": "",
      class: "overflow-hidden"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createVNode($setup["SVGWhatsApp"], { class: "h-full w-full" })
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("p", _hoisted_7, _toDisplayString($setup.t('whatsappMeta.connect.eyebrow')), 1 /* TEXT */),
                _createElementVNode("h2", _hoisted_8, _toDisplayString($setup.t('whatsappMeta.connect.title')), 1 /* TEXT */),
                _createElementVNode("p", _hoisted_9, _toDisplayString($setup.t('whatsappMeta.connect.description')), 1 /* TEXT */)
              ])
            ]),
            _createElementVNode("div", {
              class: _normalizeClass(["inline-flex w-fit items-center rounded-full px-3 py-1.5 text-sm font-medium", 
                            $setup.isConnected
                                ? 'bg-emerald-100 text-emerald-800'
                                : 'bg-gray-100 text-gray-600'
                        ])
            }, [
              _createVNode($setup["CheckCircleIcon"], {
                class: "mr-2 h-4 w-4",
                "aria-hidden": "true"
              }),
              _createTextVNode(" " + _toDisplayString($setup.isConnected
                                ? $setup.t('whatsappMeta.connect.statusConnected')
                                : $setup.t('whatsappMeta.connect.statusNotConnected')), 1 /* TEXT */)
            ], 2 /* CLASS */)
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("section", _hoisted_11, [
            _createElementVNode("h3", _hoisted_12, _toDisplayString($setup.t('whatsappMeta.connect.howItWorksTitle')), 1 /* TEXT */),
            _createElementVNode("p", _hoisted_13, _toDisplayString($setup.t('whatsappMeta.connect.howItWorksDescription')), 1 /* TEXT */),
            _createElementVNode("ol", _hoisted_14, [
              _createElementVNode("li", _hoisted_15, [
                _cache[1] || (_cache[1] = _createElementVNode("span", { class: "bg-primary flex h-7 w-7 flex-none items-center justify-center rounded-full text-sm font-semibold text-white" }, "1", -1 /* CACHED */)),
                _createElementVNode("div", null, [
                  _createElementVNode("h4", _hoisted_16, _toDisplayString($setup.t('whatsappMeta.connect.steps.account.title')), 1 /* TEXT */),
                  _createElementVNode("p", _hoisted_17, _toDisplayString($setup.t('whatsappMeta.connect.steps.account.description')), 1 /* TEXT */)
                ])
              ]),
              _createElementVNode("li", _hoisted_18, [
                _cache[2] || (_cache[2] = _createElementVNode("span", { class: "bg-primary flex h-7 w-7 flex-none items-center justify-center rounded-full text-sm font-semibold text-white" }, "2", -1 /* CACHED */)),
                _createElementVNode("div", null, [
                  _createElementVNode("h4", _hoisted_19, _toDisplayString($setup.t('whatsappMeta.connect.steps.number.title')), 1 /* TEXT */),
                  _createElementVNode("p", _hoisted_20, _toDisplayString($setup.t('whatsappMeta.connect.steps.number.description')), 1 /* TEXT */)
                ])
              ]),
              _createElementVNode("li", _hoisted_21, [
                _cache[3] || (_cache[3] = _createElementVNode("span", { class: "bg-primary flex h-7 w-7 flex-none items-center justify-center rounded-full text-sm font-semibold text-white" }, "3", -1 /* CACHED */)),
                _createElementVNode("div", null, [
                  _createElementVNode("h4", _hoisted_22, _toDisplayString($setup.t('whatsappMeta.connect.steps.authorize.title')), 1 /* TEXT */),
                  _createElementVNode("p", _hoisted_23, _toDisplayString($setup.t('whatsappMeta.connect.steps.authorize.description')), 1 /* TEXT */)
                ])
              ])
            ])
          ]),
          _createElementVNode("aside", _hoisted_24, [
            _createElementVNode("fieldset", _hoisted_25, [
              _createElementVNode("legend", _hoisted_26, _toDisplayString($setup.t('whatsappMeta.connect.modeTitle')), 1 /* TEXT */),
              _createElementVNode("h3", _hoisted_27, _toDisplayString($setup.t('whatsappMeta.connect.modeTitle')), 1 /* TEXT */),
              _createElementVNode("div", _hoisted_28, [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList($setup.signupModes, (mode) => {
                  return _createElementVNode("label", {
                    key: mode,
                    class: _normalizeClass(["flex cursor-pointer gap-3 rounded-lg border p-3 transition-colors", 
                                    $setup.signupMode === mode
                                        ? 'border-primary bg-primary/5'
                                        : 'border-gray-200 hover:bg-gray-50'
                                ])
                  }, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.signupMode) = $event)),
                      type: "radio",
                      name: "signup-mode",
                      value: mode,
                      disabled: $setup.isSignupInProgress,
                      class: "text-primary focus:ring-primary mt-0.5 h-4 w-4 border-gray-300"
                    }, null, 8 /* PROPS */, _hoisted_29), [
                      [_vModelRadio, $setup.signupMode]
                    ]),
                    _createElementVNode("span", null, [
                      _createElementVNode("span", _hoisted_30, [
                        _createTextVNode(_toDisplayString($setup.t(`whatsappMeta.connect.modes.${mode}.title`)) + " ", 1 /* TEXT */),
                        (mode === 'EXISTING_WABA')
                          ? (_openBlock(), _createBlock(_component_UiBadge, {
                              key: 0,
                              variant: "green",
                              size: "xs"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString($setup.t('whatsappMeta.connect.recommended')), 1 /* TEXT */)
                              ]),
                              _: 1 /* STABLE */
                            }))
                          : _createCommentVNode("v-if", true)
                      ]),
                      _createElementVNode("span", _hoisted_31, _toDisplayString($setup.t(`whatsappMeta.connect.modes.${mode}.description`)), 1 /* TEXT */)
                    ])
                  ], 2 /* CLASS */)
                }), 64 /* STABLE_FRAGMENT */)),
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList($setup.comingSoonModes, (mode) => {
                  return _createElementVNode("div", {
                    key: mode,
                    class: "flex gap-3 rounded-lg border border-dashed border-gray-200 p-3 text-gray-500",
                    "aria-disabled": "true"
                  }, [
                    _cache[4] || (_cache[4] = _createElementVNode("span", { class: "mt-0.5 h-4 w-4 flex-none rounded-full border border-gray-300" }, null, -1 /* CACHED */)),
                    _createElementVNode("span", null, [
                      _createElementVNode("span", _hoisted_32, [
                        _createTextVNode(_toDisplayString($setup.t(`whatsappMeta.connect.${mode}.title`)) + " ", 1 /* TEXT */),
                        _createVNode(_component_UiBadge, {
                          variant: "gray",
                          size: "xs"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString($setup.t('whatsappMeta.connect.comingSoon')), 1 /* TEXT */)
                          ]),
                          _: 1 /* STABLE */
                        })
                      ]),
                      _createElementVNode("span", _hoisted_33, _toDisplayString($setup.t(`whatsappMeta.connect.${mode}.description`)), 1 /* TEXT */)
                    ])
                  ])
                }), 64 /* STABLE_FRAGMENT */))
              ])
            ]),
            _createElementVNode("div", _hoisted_34, [
              _createElementVNode("div", _hoisted_35, [
                _createVNode($setup["ShieldCheckIcon"], {
                  class: "h-5 w-5 text-emerald-600",
                  "aria-hidden": "true"
                }),
                _createTextVNode(" " + _toDisplayString($setup.t('whatsappMeta.connect.secureTitle')), 1 /* TEXT */)
              ]),
              _createElementVNode("p", _hoisted_36, _toDisplayString($setup.t('whatsappMeta.connect.secureDescription')), 1 /* TEXT */)
            ]),
            _createElementVNode("div", _hoisted_37, [
              _createElementVNode("h3", _hoisted_38, _toDisplayString($setup.isConnected
                                    ? $setup.t('whatsappMeta.connect.connectedTitle')
                                    : $setup.t('whatsappMeta.connect.readyTitle')), 1 /* TEXT */),
              _createElementVNode("p", _hoisted_39, _toDisplayString($setup.isConnected
                                    ? $setup.t('whatsappMeta.connect.connectedDescription')
                                    : $setup.t('whatsappMeta.connect.readyDescription')), 1 /* TEXT */),
              (_ctx.$can($setup.Permission.EDIT_INTEGRATION))
                ? (_openBlock(), _createBlock(_component_UiButton, {
                    key: 0,
                    variant: "primary",
                    "text-variant": "white",
                    class: "mt-5 w-full",
                    disabled: $setup.isSignupInProgress,
                    onClick: $setup.onConnectClick
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", null, _toDisplayString($setup.isSignupInProgress
                                        ? $setup.t('whatsappMeta.connect.waitingForMeta')
                                        : $setup.connectionButtonLabel), 1 /* TEXT */),
                      _createVNode($setup["ArrowRightIcon"], {
                        class: "ml-2 h-4 w-4",
                        "aria-hidden": "true"
                      })
                    ]),
                    _: 1 /* STABLE */
                  }, 8 /* PROPS */, ["disabled"]))
                : _createCommentVNode("v-if", true),
              _createElementVNode("p", _hoisted_40, [
                _createVNode($setup["ExternalLinkIcon"], {
                  class: "mr-1.5 mt-0.5 h-3.5 w-3.5 flex-none",
                  "aria-hidden": "true"
                }),
                _createTextVNode(" " + _toDisplayString($setup.isSignupInProgress
                                    ? $setup.t('whatsappMeta.connect.waitingForMetaDescription')
                                    : $setup.t('whatsappMeta.connect.redirectNotice')), 1 /* TEXT */)
              ])
            ])
          ])
        ])
      ]),
      _: 1 /* STABLE */
    }),
    ($setup.connection)
      ? (_openBlock(), _createBlock($setup["WhatsAppAssetStatusPanel"], {
          key: 0,
          connection: $setup.connection,
          onConfirm: $setup.onConfirmConnection
        }, null, 8 /* PROPS */, ["connection"]))
      : _createCommentVNode("v-if", true),
    _createElementVNode("div", _hoisted_41, [
      _createVNode(_component_UiBackButton, { fallbackTo: { name: 'ListIntegration' } })
    ])
  ]))
}